export default "assets/point-a2ddb656.svg";